var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['s-align-5', _vm.view.class]},[_c(_vm.view.icon,{tag:"component",class:_vm.view.iconStyle,attrs:{"size":_vm.view.iconSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }